{
  "CHOOSE_LANGUAGE": "Choose Your Language",
  "CHOOSE_LANGUAGE_DESC": "Select your preferred language to customize your app experience.",
  "CONTINUE": "Continue",
  "MOBILE_NUMBER": "Mobile Number",
  "GET_OTP": "Get OTP",
  "ENTER_OTP": "Enter OTP",
  "VERIFY": "Verify",
  "RESEND_OTP": "Resend OTP",
  "RESEND_OTP_IN": "Resend OTP in",
  "LOGIN": "Login",
  "LOGOUT": "Logout",
  "DASHBOARD": "Dashboard",
  "MODAL_OTP_SENT_TITLE": "OTP Sent",
  "MODAL_OTP_SENT_MSG": "An OTP has been sent to your mobile number. Please check your messages.",
  "MODAL_INVALID_DATA_TITLE": "Invalid Data",
  "MODAL_INVALID_DATA_MSG": "Please enter valid data.",
  "BUSINESSES": "Businesses",
  "MY_BUSINESSES": "My Businesses",
  "CREATE_BUSINESS": "Create Business",
  "BUSINESS_NAME": "Business Name",
  "BUSINESS_CATEGORY": "Category",
  "PHONE": "Phone Number",
  "EMAIL": "Email",
  "GST_NUMBER": "GST / Tax ID",
  "ADDRESS_LINE_1": "Address Line 1",
  "ADDRESS_LINE_2": "Address Line 2",
  "PINCODE": "Pincode",
  "DISTRICT": "District",
  "STATE": "State",
  "DESCRIPTION": "Description",
  "SAVE": "Save",
  "CANCEL": "Cancel",
  "BACK": "Back",
  "NO_BUSINESSES_FOUND": "No businesses found",
  "CREATE_YOUR_FIRST_BUSINESS": "Create your first business to start managing operations.",
  "BUSINESS_NOT_FOUND": "Business Not Found",
  "PENDING": "Pending",
  "APPROVED": "Approved",
  "REJECTED": "Rejected",
  "APPROVE": "Approve",
  "REJECT": "Reject",
  "ALL": "All",
  "NO_APPROVED_BUSINESSES": "No approved businesses available yet",
  "ADMIN_BUSINESS_MANAGEMENT": "Business Approvals & Management",
  "EDIT_BUSINESS": "Edit Business",
  "UPDATE_BUSINESS": "Update Business",
  "NAV_HOME": "Home",
  "NAV_SCAN": "Scan QR",
  "NAV_BUSINESSES": "Stores",
  "NAV_ACCOUNT": "Account"
}
